import { supportedLocales } from '@estimating/i18n';
import { z } from 'zod';

export const BrandIdSchema = z.enum(['imex', 'rome']);
export type BrandId = z.infer<typeof BrandIdSchema>;

const LocaleSchema = z.enum(supportedLocales);

/**
 * Brand configuration (D-021). Tokens only — no UI-library types — so the web
 * app, PDFs and emails can each map them to their own theming.
 */
export const BrandConfigSchema = z
  .object({
    id: BrandIdSchema,
    productName: z.string().min(1),
    shortName: z.string().min(1),
    /**
     * The shop management system this brand pairs with. Its accounts sign in here,
     * through the same Firebase project (D-036, D-060).
     */
    platformName: z.string().min(1),
    defaultLocale: LocaleSchema,
    supportedLocales: z.array(LocaleSchema).nonempty(),
    currency: z.enum(['CAD', 'USD']),
    theme: z.object({
      colorPrimary: z.string().regex(/^#[0-9a-f]{6}$/i, 'Expected a hex colour such as #1f4e79'),
      borderRadius: z.number().int().min(0).max(24),
    }),
  })
  .refine((brand) => brand.supportedLocales.includes(brand.defaultLocale), {
    message: 'defaultLocale must be one of supportedLocales',
    path: ['defaultLocale'],
  });
export type BrandConfig = z.infer<typeof BrandConfigSchema>;
